import { ResourceOptions } from 'react-admin';
import { FaTrophy } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.blindBoxWinRecords;
export const icon = FaTrophy;
export const options: ResourceOptions = {
  label: 'module.blindBox.winRecords',
};
